import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ListWidgetComponent,
  VideoPreviewWidgetComponent,
} from '@outlaw/community';
import { VideoWidget } from '@outlaw/community/interfaces/view-widget';

@Component({
  selector: 'app-latest-videos-widget',
  standalone: true,
  imports: [CommonModule, ListWidgetComponent, VideoPreviewWidgetComponent],
  templateUrl: './latest-videos-widget.component.html',
  styleUrls: ['./latest-videos-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LatestVideosWidgetComponent {
  protected readonly title = 'Latest Videos';

  protected readonly videoPreviewData: VideoWidget[] = [
    {
      title: 'The FINAL Dhar Mann Video Ever!?',
      thumbnailUrl: '/assets/video/dhar-mann-video1.jpg',
      url: 'https://www.youtube.com/watch?v=Sb-VwrQA49M',
    },
    {
      title: 'Girl Fakes As ARIANA GRANDE To Meet Crush | Dhar Mann Studios',
      thumbnailUrl: '/assets/video/dhar-mann-video2.jpg',
      url: 'https://www.youtube.com/watch?v=aec9yF_KkLs',
    },
    {
      title: 'Caleb Synan: 30 - Full Special',
      thumbnailUrl: '/assets/video/dhar-mann-video3.jpg',
      url: 'https://www.youtube.com/watch?v=mNk8l_ku7qA',
    },
  ];
}
